module.exports = __webpack_public_path__ + "static/media/no-result-assess.b28228b1.png";